import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useHasScrolled } from '@atlassiansox/bxp-content-framework';
import { BigNav } from './big';
import { SmallNav } from './small';
import { useIsLoggedIn, useSignupUrl } from '../../components';
import { Skip } from './UiHeaderNav.styles';
import { getCookie } from '../../utils';
export default function UiHeaderNav({ model: model }) {
    var _a;
    const { content: { useAtlassianAccess } } = model;
    const identitySignupUrl = useSignupUrl();
    const [nativeAaCookieStatus, setNativeAaCookieStatus] = useState(null);
    useEffect(() => {
        setNativeAaCookieStatus(getCookie('native_aa'));
    }, [nativeAaCookieStatus]);
    const signUpUrl = useAtlassianAccess || nativeAaCookieStatus === 'true'
        ? identitySignupUrl
        : '/signup';
    const hasScrolled = useHasScrolled(40);
    const isLoggedIn = useIsLoggedIn();
    return (_jsxs(_Fragment, { children: [_jsx(Skip, { children: _jsx("a", Object.assign({ id: "skip-to-content", href: "#skip-target", className: "visually-hidden" }, { children: (_a = model.content.skipToMainContent) !== null && _a !== void 0 ? _a : 'Skip to main content' }), void 0) }, void 0), _jsx(BigNav, { hasScrolled: hasScrolled, isLoggedIn: isLoggedIn, model: model, signUpUrl: signUpUrl }, void 0), _jsx(SmallNav, { hasScrolled: hasScrolled, isLoggedIn: isLoggedIn, model: model, signUpUrl: signUpUrl }, void 0)] }, void 0));
}
//# sourceMappingURL=UiHeaderNav.js.map